import getPolicyAwareNotificationsEnabled from "../utils/getPolicyAwareNotificationsEnabled";

export default function areNotificationsEnabled(): boolean {
    return getPolicyAwareNotificationsEnabled();
}
